// Pass all teh reducers that need to have a persistant state into the array

const whitelist = [
	'navigation',
];

export default whitelist;